import React from 'react'
import styled from 'styled-components'
import { useWindowResize } from 'hooks'
import MoreEventsMobile from './MoreEventsMobile'
import MyEventsCarousel from 'components_v1/EventsView/MyEventsCarousel'

const Container = styled('div')({
  marginBottom: '12px'
})

const MoreEvents = ({
  events,
  totalCount,
  loadNextPageData = () => {},
  currentPage
}) => {
  const { width } = useWindowResize()
  const isMobile = width < 768
  return (
    <Container>
      {isMobile ? (
        <MoreEventsMobile
          events={events}
          section={'myEvents'}
          totalCount={events?.length}
          loadNextPageData={loadNextPageData}
          currentPage={1}
        />
      ) : (
        <MyEventsCarousel
          events={events}
          totalCount={events?.length}
          currentPage={1}
          isMoreEventsCarousel={true}
          slidesPerViewOnLargeScreen={3}
        />
      )}
    </Container>
  )
}
export default MoreEvents
